import { Component, OnInit } from '@angular/core';
import { HostListener } from '@angular/core';

import { ConnectionService } from 'src/app/service/connection.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { formatDate } from '@angular/common';

import { FirebaseService } from 'src/app/service/firebase.service';





@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  currentDate: any = new Date();

  disabledSubmitButton: boolean = true;
  optionsSelect: Array<any> = [];

  constructor(private fb: FormBuilder, private connectionService: ConnectionService, private fs: FirebaseService) {
    localStorage.clear();

    this.contactForm = fb.group({
      firstName: ['', [Validators.required, Validators.minLength(3), Validators.pattern('[a-zA-Z ]*')]],
      lastName: ['', [Validators.required, Validators.minLength(3), Validators.pattern('[a-zA-Z ]*')]],
      email: ['', Validators.compose([Validators.required, Validators.email])],
      pNumber: ['', [Validators.required, Validators.pattern('[0-9]*')]],
      message: ['', [Validators.required, Validators.minLength(3)]],

    });
  }

  dates: any;
  ngOnInit(): void {
    console.log(this.currentDate);
    this.currentDate = this.currentDate.toString().split(" ");

    this.dates = this.currentDate[1] + " " + this.currentDate[2] + " " + this.currentDate[3] + ", " + this.currentDate[4];
    console.log(this.dates);


  }

  @HostListener("window:scroll", []) onWindowScroll() {
    this.scrollFunction();
  }
  // When the user scrolls down 20px from the top of the document, show the button
  scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      document.getElementById("myBtn")!.style.display = "block";

      document.getElementById("responsive")!.style.color = "black";

      document.getElementById("myTopnav")!.style.backgroundColor = "#ffffffda";
    } else {
      document.getElementById("myBtn")!.style.display = "none";

      document.getElementById("myTopnav")!.style.backgroundColor = "transparent";
    
      document.getElementById("responsive")!.style.color = "black";
      document.getElementById("responsive")!.style.backgroundColor = "transparent";
    }
  }

  onHome: boolean = false;
  onContact: boolean = false;
  onMessage: boolean = false;

  // When the user clicks on the button, scroll to Service
  toContact() {
    document.getElementById('toContact')?.scrollIntoView({ behavior: 'smooth' })
    this.onHome = false;
    this.onContact = true;
    this.onMessage = false;

    if (this.onContact == true) {
      document.getElementById("contact")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("message")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("contactUs")!.style.color = "rgb(255, 146, 5)";
    }
  }

  // When the user clicks on the button, scroll to the top of the document
  topFunction() {
    document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' })

    this.onHome = true;
    this.onContact = false;

    if (this.onHome == true) {
      document.getElementById("contactUs")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("contact")!.style.color = "rgb(255, 146, 5)";
    }
  }





  contactForm = this.fb.group({
    firstName: ['', [Validators.required, Validators.minLength(3), Validators.pattern('[a-zA-Z ]*')]],
    lastName: ['', [Validators.required, Validators.minLength(3), Validators.pattern('[a-zA-Z ]*')]],
    email: ['', Validators.compose([Validators.required, Validators.email])],
    pNumber: ['', [Validators.required, Validators.pattern('[0-9]*')]],
    message: ['', [Validators.required]],
  });

  get firstName() { return this.contactForm.get('firstName') }
  get lastName() { return this.contactForm.get('lastName') }
  get email() { return this.contactForm.get('email') }
  get pNumber() { return this.contactForm.get('pNumber') }
  get message() { return this.contactForm.get('message') }


  @HostListener('input') oninput() {

    if (this.contactForm.valid) {
      this.disabledSubmitButton = false;
    }
  }

  toMessage() {
    document.getElementById('toMessage')?.scrollIntoView({ behavior: 'smooth' })

    this.onHome = false;
    this.onContact = false;
    this.onMessage = true;

    if (this.onMessage == true) {
      document.getElementById("contactUs")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("contact")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("message")!.style.color = "rgb(255, 146, 5)";
    }
  }

  onSubmit() {
    console.log(this.contactForm.value);
    const details = {
      firstName: this.contactForm.value.firstName, lastName: this.contactForm.value.lastName, email: this.contactForm.value.email,
      pNumber: this.contactForm.value.pNumber, message: this.contactForm.value.message, date: this.dates
    };

    console.log();


    this.fs.sendMessage(details);

  }

  ok() {
    location.reload();
    // this.router.navigate(['/order']);
  }

  myFunction() {
    var x = document.getElementById("myTopnav")!;
    if (x.className === "topnav") {
      x.className += " responsive";
    } else {
      x.className = "topnav";
    }
  }
  //Close Nav
  closeNav() {
    var x = document.getElementById("myTopnav")!;
    if (x.className === "topnav") {
      
    } else {
      x.className = "topnav";
      document.getElementById("nav")!.style.color = "white";

    }
  }



}
